var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sweet-modal",
    {
      ref: "modal",
      attrs: {
        "overlay-theme": "dark",
        icon: "success",
        "enable-mobile-fullscreen": false
      }
    },
    [
      _vm.newOrderData
        ? _c("div", [
            _c("div", { staticClass: "mt-4" }, [
              _c(
                "h3",
                [
                  _vm.newOrderData.isInstantBooking
                    ? [
                        _c("i", {
                          staticClass: "fas fa-bolt -status-instant-book"
                        }),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "message.booking.complete_step.title_instant_booking"
                              )
                            ) +
                            "\n        "
                        )
                      ]
                    : [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("message.booking.complete_step.title")
                            ) +
                            "\n        "
                        )
                      ],
                  _vm._v(
                    "\n        — " +
                      _vm._s(_vm.$t("message.my_reservations.booking")) +
                      " #" +
                      _vm._s(_vm.newOrderData.orderCode) +
                      "\n      "
                  )
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mt-4" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("message.booking.checkout_step.success_message01")
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-3" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("message.booking.checkout_step.success_message02")
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-3 text-info" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("message.booking.checkout_step.success_message03")
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-4" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info btn-block",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.goToMyBooking.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "message.booking.complete_step.view_my_booking"
                          )
                        ) +
                        "\n        "
                    )
                  ]
                )
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-454b4964", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-454b4964","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/SuccessBookingModal.vue
// module id = 1453
// module chunks = 0